angular.module('gym.calendar').directive('editEventScheduleActivity', function() {
  return {
    restrict: 'E',
    template: require('templates/gyms/calendar/events/edit_event_schedule/edit_event_schedule_activity.html.slim'),
    scope: {
      event: '='
    }
  };
});
